<ng-container *ngIf="compositionStrings?.length > 0">
  {{'Composition' | translate}}:
  <ng-container *ngFor="let section of compositionStrings">
    <span>{{section}}</span>
  </ng-container>
</ng-container>
